import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { RootState } from 'app/store';
import { GetWorkspaceNewMessagesCounterPayload, NotificationWorkspacecounterResponse } from "generated/CoreApi_v1";
import { coreApiV1 } from "providers/CoreApiProvider";

// Estado que será utilizado pelo REDUCER
interface NotificationState {
    newMessages: NotificationWorkspacecounterResponse;
}

// Estado Inicial
const initialState: NotificationState = {
    newMessages: {
        newDirectMessages: false,
        priorityNotifications: 0,
        regularNotifications: 0
    }
};

// Cria Reducer's através de SLICE.
const notificationSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        resetWorkspace: (state) => state = {
            newMessages: {
                newDirectMessages: false,
                priorityNotifications: 0,
                regularNotifications: 0
            }
        }
    },
    extraReducers: (builder) => {
        ///
        builder.addCase(getNewMessagesCounter.fulfilled,
            (state, { payload }) => {
                state.newMessages = payload;
            });

    }
});

export const { resetWorkspace } = notificationSlice.actions;
export default notificationSlice.reducer;

//#region Selectors

export const notificationCounter = (state: RootState) => state.notifications.newMessages;

//#endregion


//#region Async Thunk

///
export const getNewMessagesCounter = createAsyncThunk<NotificationWorkspacecounterResponse, GetWorkspaceNewMessagesCounterPayload, { rejectValue: ApiProblemErrors; }>
    ("notifications/getWorkspaceNewMessagesCounter", async (p, thunkApi) => {
        try {
            const response = await coreApiV1.notification.getWorkspaceNewMessagesCounter(p);
            return response.data;
        }
        catch (e) {
            return thunkApi.rejectWithValue(e as ApiProblemErrors);
        }
    });

//#endregion
